/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationEvaluationOptionDtoEvaluationState } from './CreateEnumerationEvaluationOptionDtoEvaluationState';
import {
    CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSON,
    CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSONTyped,
    CreateEnumerationEvaluationOptionDtoEvaluationStateToJSON,
} from './CreateEnumerationEvaluationOptionDtoEvaluationState';

/**
 * 
 * @export
 * @interface CreateEnumerationEvaluationOptionDto
 */
export interface CreateEnumerationEvaluationOptionDto {
    /**
     * 
     * @type {number}
     * @memberof CreateEnumerationEvaluationOptionDto
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationEvaluationOptionDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {CreateEnumerationEvaluationOptionDtoEvaluationState}
     * @memberof CreateEnumerationEvaluationOptionDto
     */
    evaluationState?: CreateEnumerationEvaluationOptionDtoEvaluationState | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationEvaluationOptionDto
     */
    $type?: CreateEnumerationEvaluationOptionDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEnumerationEvaluationOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEnumerationEvaluationOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEnumerationEvaluationOptionDtoTypeEnum = typeof CreateEnumerationEvaluationOptionDtoTypeEnum[keyof typeof CreateEnumerationEvaluationOptionDtoTypeEnum];



/**
 * Check if a given object implements the CreateEnumerationEvaluationOptionDto interface.
 */
export function instanceOfCreateEnumerationEvaluationOptionDto(value?: unknown): value is CreateEnumerationEvaluationOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEnumerationEvaluationOptionDtoTypeEnum)[0];
}

export function CreateEnumerationEvaluationOptionDtoFromJSON(json: any): CreateEnumerationEvaluationOptionDto {
    return CreateEnumerationEvaluationOptionDtoFromJSONTyped(json, false);
}

export function CreateEnumerationEvaluationOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationEvaluationOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'evaluationState': json['evaluationState'] == null ? undefined : CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSON(json['evaluationState']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateEnumerationEvaluationOptionDtoToJSON(value?: CreateEnumerationEvaluationOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'isEnabled': value['isEnabled'],
        'evaluationState': CreateEnumerationEvaluationOptionDtoEvaluationStateToJSON(value['evaluationState']),
        '$type': value['$type'],
    });
}

